// ServicesSection.jsx
import React from "react";

const services = [
  {
    title: "Football Turf Installation",
    description: "High-performance FIFA-standard football turf for training grounds & stadiums.",
    image: "/images/football-turf-icon.png",
  },
  {
    title: "Box Cricket Turf",
    description: "Durable, shock-absorbent turf perfect for indoor & outdoor box cricket arenas.",
    image: "/images/cricket-turf-icon.png",
  },
  {
    title: "Multi-Sport Court",
    description: "Versatile surfaces ideal for tennis, basketball, volleyball & more.",
    image: "/images/multisport-icon.png",
  },
  {
    title: "Turf Maintenance",
    description: "Professional cleaning, brushing, and grooming to increase turf lifespan.",
    image: "/images/maintenance-icon.png",
  },
];

const ServicesSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">

        <h2 className="text-3xl md:text-4xl font-extrabold text-center bg-gradient-to-r from-green-600 via-emerald-500 to-lime-400 bg-clip-text text-transparent">
          Our Products & Services
        </h2>

        <p className="text-lg text-center text-gray-700 max-w-3xl mx-auto mt-4 mb-12">
          ZajraGreen specializes in constructing premium sports turfs across India — from football
          grounds to box cricket arenas, multi-sport courts, and complete turf maintenance solutions.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-20 h-20 object-contain mb-4"
              />
              <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ServicesSection;
